import React, {useState} from 'react';
// material
import { Button, Card, CardContent, Grid, withStyles, TextField, FormControlLabel, Checkbox} from '@material-ui/core';
//styles
import styles from './handicap-card-styles';
//utils
import _ from 'lodash';

const HandicapCardEdit = (props) => {
  const {classes, setIsEdit, submitScores, details} = props;
  const [state, setState] = useState({
    handicap: details.handicap ? details.handicap : '0',
    handicapIndex: details.handicapIndex,
    handicapNumber: details.handicapNumber,
    isOfficialHandicap: details.isOfficialHandicap,
    userId: details.userId
  });

  const handleSetState = (e) => {
    e.persist();
    setState((prevState => ({...prevState, [e.target.name]: e.target.value})));
  };

  const handleSetHandicapCheckbox = () =>
    setState((prevState => ({...prevState, isOfficialHandicap: !state.isOfficialHandicap})));

  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Handicap</Grid>
        </Grid>
        <Grid container className={classes.displayBody} spacing={2}>
          <Grid item xs={12} sm={7}>
            {
              !state.isOfficialHandicap &&
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    label={'Official Handicap'}
                    control={<Checkbox name='isOfficialHandicap' color={'primary'} checked={state.isOfficialHandicap} onChange={handleSetHandicapCheckbox}/>} />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'Handicap'}
                    value={state.handicap}
                    name={'handicap'}
                    onChange={handleSetState}
                    type={'number'}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            }

            {
              state.isOfficialHandicap &&
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    label={'Official Handicap'}
                    control={<Checkbox name='isOfficialHandicap' color={'primary'} checked={state.isOfficialHandicap} onChange={handleSetHandicapCheckbox}/>} />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'Handicap Index'}
                    value={state.handicapIndex}
                    name={'handicapIndex'}
                    onChange={handleSetState}
                    type={'number'}
                    variant={'outlined'}/>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'CDH Number'}
                    value={state.handicapNumber}
                    name={'handicapNumber'}
                    onChange={handleSetState}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            }
          </Grid>

          <Grid item xs={12} sm={12}>
            <Grid
              container
              spacing={2}>
              <Grid item>
                <Button color={'primary'} size={'small'} variant={'contained'} onClick={() => submitScores(state)} disabled={((!state.isOfficialHandicap && !_.isInteger(parseInt(state.handicap))) || (state.isOfficialHandicap && !_.isInteger(parseInt(state.handicapIndex)) && state.handicapNumber))}>Save</Button>
              </Grid>
              <Grid item>
                <Button color={'primary'} size={'small'} onClick={() => setIsEdit(false)}>Cancel</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (HandicapCardEdit);
